<template>
  <el-container class="app-wrapper">
    <!-- 顶部导航 -->
    <el-header height="60px" class="app-header">
      <!-- 原左侧区域（logo + 水平菜单）已注释，现放置多标签页 -->
      <!-- <div class="header-left">
        <div class="logo" @click="_toIndex">{{ systemInfo.systemSimpleTitle }}</div>
        <el-menu mode="horizontal" :default-active="activeMenu" class="header-menu" background-color="#1e2132"
          text-color="#fff" active-text-color="#409EFF">
          <template v-for="(item, index) in catalogs">
            <el-menu-item :index="item.caId" v-if="!item.privId || hasPrivilege(item.privId)" :key="index"
              @click="_changeMenuCatalog(item, true)">{{ item.name }}</el-menu-item>
          </template>
        </el-menu>
      </div> -->

      
      <div class="header-left">
        <div class="logo" :class="{ 'logo-collapse': isCollapse }" @click="_toIndex">
          <img src="../../../public/img/lindianLogo.png" alt="">
        </div>

        <el-menu mode="horizontal" :default-active="activeMenu" class="header-menu" background-color="#1e2132"
          text-color="#fff" active-text-color="#409EFF">
          <template v-for="(item, index) in catalogs">
            <el-menu-item :index="item.caId" v-if="!item.privId || hasPrivilege(item.privId)" :key="index"
              @click="_changeMenuCatalog(item, true)">{{ item.name }}</el-menu-item>
          </template>
        </el-menu>
        
        <div class="tabs-wrap" v-if="visitedTabs.length > 0">
          <div class="tabs-list">
            <div
              v-for="tab in visitedTabs"
              :key="tab.path"
              :class="['tabs-item', { active: $route.path === tab.path }]"
              @click="goTab(tab)"
            >
              <span class="tabs-item-title">{{ tab.titleKey ? $t(tab.titleKey) : tab.title }}</span>
              <i class="el-icon-close tabs-item-close" @click.stop="removeTab(tab)" v-if="visitedTabs.length > 1"></i>
            </div>
          </div>
          <el-button type="text" size="mini" class="tabs-close-all" @click="closeAllTabs">
            {{ $t('layout.closeAllTabs') }}
          </el-button>
        </div>
      </div>

      <!-- 右侧内容保持不变 -->
      <div class="header-right">
        <el-dropdown @command="changeCommunity" v-if="storeInfo.storeTypeCd == '800900000003'" class="margin-right">
          <span class="user-info">
            {{ curCommunityName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="c" v-for="(c, index) in communitys" :key="index">{{ c.name }}</el-dropdown-item>
            <el-dropdown-item command="moreCommunity" class="moreCommunity">{{ $t('layout.moreCommunity')
              }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown @command="handleCommand">
          <span class="user-info">
            {{ username }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">{{ $t('layout.logout') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="margin-left">{{ systemInfo.version }}</span>
      </div>
    </el-header>

    <el-container>
      <!-- 左侧菜单 - Element UI 侧栏导航 -->
      <!-- 动态宽度，结合媒体查询实现响应式 -->
      <el-aside class="app-aside" :width="isCollapse ? '64px' : '250px'">
        <el-menu
          :default-active="activeMenuPath"
          class="el-menu-vertical"
          background-color="#1e2132"          
          text-color="#fff"                
          active-text-color="#409EFF"
          :collapse="isCollapse"
          :collapse-transition="false"
          @select="handleMenuSelect"
        >
          <template v-for="(menu, index) in menuTree">
            <!-- 有子菜单 -->
            <el-submenu v-if="menu.childs && menu.childs.length" :index="menu.id" :key="menu.id">
              <template slot="title">
                <i class="fa" :class="menu.icon"></i>
                <span slot="title">{{ menu.name }}</span>
              </template>
              <el-menu-item
                v-for="(child, childIndex) in menu.childs"
                :key="childIndex"
                :index="child.href"
                v-if="child.isShow == 'Y'"
              >
                <i class="fa" :class="child.icon"></i>
                <span slot="title">{{ child.name }}</span>
              </el-menu-item>
            </el-submenu>
            <!-- 无子菜单，直接作为菜单项 -->
            <el-menu-item v-else :index="menu.href" :key="index">
              <i class="fa" :class="menu.icon"></i>
              <span slot="title">{{ menu.name }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>

      <!-- 主要内容区 -->
      <el-main class="app-main">
        <router-view />
      </el-main>
    </el-container>

    <!-- 弹窗组件 -->
    <more-community ref="moreCommunity" />
    <view-menu-user-list ref="viewMenuUserModel" />
    <search-community-data-list ref="searchCommunityDataModel" />
  </el-container>
</template>

<script>
import { _getMenuCatalog, getMenuTree, jumpToMall, jumpToIot } from '@/api/user/menuApi'
import { getStoreInfo } from "@/api/user/indexApi"
import { listSystemInfo } from '@/api/system/systemInfoManageApi'
import { deepCopy, setCurrentCommunity } from "@/utils/vc"
import { getCommunityName, _loadCommunityInfo } from '@/api/community/communityApi'
import moreCommunity from '@/components/community/moreCommunity.vue'
import viewMenuUserList from '@/components/system/viewMenuUserList.vue'
import searchCommunityDataList from '@/components/system/searchCommunityDataList.vue'
import { initSystem } from '@/api/util/vcApi'
import config from '@/conf/config'

export default {
  name: 'Layout',
  data() {
    return {
      catalogs: [],
      menuTree: [],
      activeMenuPath: '', // 当前激活的菜单项路径（用于高亮联动）
      activeMenu: '',
      searchText: '',
      username: '',
      curCommunityName: '',
      communitys: [],
      storeInfo: {
        storeTypeCd: '',
        storeId: ''
      },
      systemInfo: {
        systemSimpleTitle: '',
        companyName: '',
        logoUrl: '',
        version: ''
      },
      visitedTabs: [], // 已打开的页面 { path, titleKey?, title? }
      isCollapse: false // 控制侧边栏是否折叠
    }
  },
  watch: {
    $route: {
      handler(route) {
        if (!route.path || route.path === '/views/user/login' || route.path === '/login') return
        const path = route.path
        const exists = this.visitedTabs.some(t => t.path === path)
        if (!exists) {
          const info = this.getTabTitle(path, route.meta || {})
          if (info) this.visitedTabs.push({ path, ...info })
        }
        // 路由变化时（包括点击 Tabs 触发的跳转），同步更新左侧菜单高亮
        this.updateActiveMenu()
      },
      immediate: true
    }
  },
  created() {
    let _user = JSON.parse(localStorage.getItem('user') || '{}');
    this.username = _user.name || ''
    this.systemInfo.version = config.version
    this.getSystemInfo()
    this._loadStoreInfo()
    this.loadCatalogs()
    this.curCommunityName = getCommunityName()
    this.loadCommunity()
    initSystem()
  },
  mounted() {
    // 初始化响应式监听
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // 销毁时移除监听
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    moreCommunity,
    viewMenuUserList,
    searchCommunityDataList
  },
  methods: {
    // 响应式处理
    handleResize() {
      // 当屏幕宽度小于 992px 时，自动折叠左侧菜单
      this.isCollapse = window.innerWidth < 992;
    },
    // 标签页名称：仅当路由配置了 meta.title 或 meta.titleKey 时才展示该标签
    getTabTitle(path, meta) {
      if (path === '/views/index/index' || path === '/') {
        return { titleKey: 'layout.home' }
      }
      const m = meta || {}
      if (m.title) return { title: m.title }
      if (m.titleKey) return { titleKey: m.titleKey }
      return null
    },
    goTab(tab) {
      if (this.$route.path === tab.path) return
      // 跳转路由，这会触发 watch 从而调用 updateActiveMenu 联动左侧菜单高亮
      this.$router.push(tab.path).catch(() => {})
    },
    removeTab(tab) {
      const list = this.visitedTabs.filter(t => t.path !== tab.path)
      this.visitedTabs = list
      if (this.$route.path === tab.path) {
        const next = list.length ? list[list.length - 1] : { path: '/views/index/index' }
        this.$router.push(next.path).catch(() => {})
      }
    },
    closeAllTabs() {
      this.visitedTabs = []
      this.$router.push('/views/index/index').catch(() => {})
    },
    async getSystemInfo() {
      try {
        const { data } = await listSystemInfo({ page: 1, row: 1 });
        if(data && data.length > 0) {
          this.systemInfo.systemSimpleTitle = data[0].systemSimpleTitle
          this.systemInfo.companyName = data[0].companyName
          this.systemInfo.logoUrl = data[0].logoUrl
        }
      } catch (error) {
        console.error(error)
      }
    },
    async loadCommunity() {
      const { communitys } = await _loadCommunityInfo()
      this.communitys = communitys || []
      this.curCommunityName = getCommunityName()
    },
    async _loadStoreInfo() {
      try {
        const res = await getStoreInfo()
        deepCopy(res, this.storeInfo);
      } catch (error) {
        console.error('获取店铺信息失败：', error)
      }
    },
    async loadCatalogs() {
      try {
        const res = await _getMenuCatalog()
        if (res.code != 0) return
        this.catalogs = res.data;
        if (this.catalogs && this.catalogs.length > 0) {
          this._changeMenuCatalog(this.catalogs[0])
        }
      } catch (error) {
        console.error('加载目录失败：', error)
      }
    },
    _changeMenuCatalog(_catalog, _isJump) {
      this.activeMenu = _catalog.caId;
      if (this._showModelDiv(_catalog)) return;
      if (_catalog.caId === '1') {
        this.$router.push('/#/pages/mall/product');
      }
      if (_catalog.url == 'IOT') {
        jumpToIot('/');
        return;
      }
      if (_catalog.url == 'MALL') {
        jumpToMall('/');
        return;
      }
      if (_catalog.url != '#' && _isJump) {
        this._gotoPage(_catalog.url, _catalog.name)
      }
      this.loadMenuTree(_catalog)
    },
    loadMenuTree(_catalog) {
      getMenuTree(_catalog).then(res => {
        let _menus = res.data || [];
        _menus.sort((a, b) => a.seq - b.seq);
        this.menuTree = _menus;
        this.$nextTick(() => {
          this.updateActiveMenu(); // 菜单加载完成后更新高亮
        });
      })
    },
    // 更新当前激活的菜单项路径 (与 Tabs 联动)
    updateActiveMenu() {
      const currentPath = this.$route.path;
      for (const menu of this.menuTree) {
        if (menu.childs && menu.childs.length) {
          for (const child of menu.childs) {
            // 处理带参数或不带参数的路径匹配
            if (currentPath.includes(child.href) || child.href.includes(currentPath)) {
              this.activeMenuPath = child.href;
              return;
            }
          }
        } else {
          if (currentPath.includes(menu.href) || menu.href.includes(currentPath)) {
            this.activeMenuPath = menu.href;
            return;
          }
        }
      }
      // 如果没匹配到，置为空
      this.activeMenuPath = '';
    },
    // 菜单选择事件处理
    handleMenuSelect(index) {
      this._gotoPage(index); // index 为菜单项的 href
    },
    _gotoPage(_href) {
      if (_href.indexOf('.html') > -1) {
        window.open(_href, '_blank')
        return
      }
      if (_href.indexOf('/#/') > -1) {
        _href = _href.replace('/#/', '/')
      }
      this.$router.push(_href).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err
      })
    },
    _showModelDiv(_catalog) {
      if (_catalog.url && _catalog.url.startsWith('?')) {
        let _modelName = _catalog.url.substring(1);
        if(this.$refs[_modelName]){
           this.$refs[_modelName].open()
        }
        return true;
      }
      return false;
    },
    handleCommand(command) {
      if (command === 'logout') {
        localStorage.removeItem('token')
        localStorage.clear();
        this.$router.push('/login')
      } else if (command === 'zh' || command === 'en') {
        this.$i18n.locale = command
        localStorage.setItem('language', command)
      }
    },
    changeCommunity(community) {
      if (community == 'moreCommunity') {
        this.$refs.moreCommunity.open()
        return
      }
      setCurrentCommunity(community);
      this.curCommunityName = getCommunityName()
      window.location.href = "/"
    },
    _toIndex() {
      location.href = '/'
    },
  }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  height: 100vh;
}

.app-header {
  background-color: #1e2132;
  color: #fff;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  flex: 1; /* 让左侧区域可以扩展，以便标签页占满剩余空间 */
  min-width: 0; /* 防止 flex 子项溢出 */
}

.logo {
  width: 250px; /* 与菜单宽度保持一致 */
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center; /* 居中 */
  cursor: pointer;
  background-color: #1e2132; /* 确保背景色一致 */
  transition: width 0.3s; /* 折叠动画过渡 */
  flex-shrink: 0;
}

.logo-collapse {
  width: 64px; /* 折叠状态下的宽度 */
}

.logo img {
  max-width: 80%;
  max-height: 80%;
  object-fit: contain;
}

.header-menu {
  border: none;
}

.header-right {
  display: flex;
  align-items: center;
  margin-right: 20px;
  flex-shrink: 0; /* 防止右侧被压缩 */
  color: #fff; /* 字体设置成白色 */
}

.margin-left {
  margin-left: 15px;
  color: #fff; /* 字体设置成白色 */
}

.user-info {
  color: #fff; /* 字体设置成白色 */
  cursor: pointer;
}

/* 侧边栏及动画 */
.app-aside {
  background-color: #1e2132;
  transition: width 0.3s; /* 使展开收起更平滑 */
  overflow: hidden;
}

/* Element UI 菜单样式微调 */
.el-menu-vertical {
  border-right: none;
  height: calc(100vh - 60px);
  overflow-y: auto;
  overflow-x: hidden;
}

/* 隐藏菜单的滚动条，但保留滚动功能 */
.el-menu-vertical::-webkit-scrollbar {
  display: none;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 100%;
}

/* 确保图标与文字间距 */
.el-menu-item [class^="fa"],
.el-submenu [class^="fa"] {
  margin-right: 10px;
  width: 20px;
  text-align: center;
}

.app-main {
  background-color: #f5f7fa;
  height: calc(100vh - 60px);
  padding: 0px;
  overflow: auto;
}

/* 多标签页样式 - 调整以适应顶部导航栏深色背景 */
.tabs-wrap {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background: transparent; /* 背景透明融入 header */
  gap: 8px;
  flex: 1; /* 占据剩余空间，避免挤压右侧 */
  min-width: 0; /* 防止溢出 */
}
.tabs-list {
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
  flex: 1;
  min-width: 0;
  overflow-x: auto;
  /* 隐藏滚动条 */
  &::-webkit-scrollbar {
    display: none;
  }
}
.tabs-item {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  font-size: 13px;
  border-radius: 4px;
  cursor: pointer;
  color: #b0b3c2;
  background: #2a2f45;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: 1px solid #3a4055;
}
.tabs-item:hover {
  color: #fff;
  background: #3a4055;
}
.tabs-item.active {
  color: #fff;
  background: #409EFF;
  font-weight: 500;
  border-color: #409EFF;
}
.tabs-item-title {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tabs-item-close {
  margin-left: 6px;
  font-size: 12px;
  opacity: 0.7;
}
.tabs-item-close:hover {
  opacity: 1;
  color: #f56c6c;
}
.tabs-close-all {
  flex-shrink: 0;
  padding: 4px 8px;
  color: #b0b3c2;
}
.tabs-close-all:hover {
  color: #fff;
}

:deep(.el-menu--horizontal) {
  border-bottom: none;
}

:deep(.el-menu-item) {
  height: 50px;
  line-height: 50px;
}

:deep(.el-submenu__title) {
  height: 50px;
  line-height: 50px;
  padding: 0 20px !important;
}

:deep(.el-menu--collapse) {
  width: 64px;
}

:deep(.el-menu--collapse .el-submenu__title) {
  padding: 0 !important;
  text-align: center;
}

:deep(.el-menu--collapse .el-submenu__title i) {
  margin: 0;
  font-size: 20px;
}

/* 浮动菜单（折叠时显示的悬浮框）深色主题 */
:deep(.el-menu--popup) {
  min-width: 200px;
  background-color: #1e2132 !important;
}

:deep(.el-menu--popup .el-menu-item) {
  background-color: #1e2132 !important;
  color: #b0b3c2 !important;
}

:deep(.el-menu--popup .el-menu-item:hover) {
  background-color: #2a2f45 !important;
  color: #fff !important;
}

:deep(.el-menu--popup .el-menu-item.is-active) {
  background-color: #409EFF !important;
  color: #fff !important;
}

/* 一级菜单悬停 */
:deep(.el-menu-vertical .el-submenu__title:hover),
:deep(.el-menu-vertical > .el-menu-item:hover) {
    background-color: #2a2f45 !important;
}

/* 子菜单容器背景色与父级区分（稍亮） */
:deep(.el-menu-vertical .el-menu--inline) {
  background-color: #151723 !important; /* 更深的背景色，体现层级 */
}

/* 子菜单项背景色（默认与容器一致） */
:deep(.el-menu-vertical .el-menu--inline .el-menu-item) {
  background-color: #151723 !important;
  color: #b0b3c2 !important;
}

/* 子菜单项悬停效果 */
:deep(.el-menu-vertical .el-menu--inline .el-menu-item:hover) {
  background-color: #2a2f45 !important;
  color: #fff !important;
}

/* 子菜单项激活状态 */
:deep(.el-menu-vertical .el-menu--inline .el-menu-item.is-active) {
  background-color: #409EFF !important;
  color: #fff !important;
}

/* 更多社区选项样式 */
.moreCommunity {
  font-weight: 600;
  color: #212529;
  font-size: 12px;
}

/* ====== 媒体查询 ====== */
@media (max-width: 992px) {
  /* 平板和小屏幕下，部分文字可隐藏节约空间 */
  .header-right .margin-left {
    display: none; 
  }
}

@media (max-width: 768px) {
  /* 手机端进一步优化 */
  .tabs-wrap {
    padding: 8px 4px;
  }
  .tabs-close-all {
    display: none; /* 手机端可隐藏全部关闭按钮 */
  }
  .header-right .user-info {
    font-size: 12px;
  }
}
</style>
